import { setupLocalStorageGuard } from './utils/localStorageGuard'
setupLocalStorageGuard()

if (process.env.NODE_ENV !== 'local' && !localStorage.getItem('forceLogs')) {
  console.log = () => {}
  console.debug = () => {}
  console.info = () => {}
}

import Vue from 'vue'
import Vuesax from 'vuesax'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VeeValidate_messages_en from 'vee-validate/dist/locale/en'
import VeeValidate_messages_fr from 'vee-validate/dist/locale/fr'
import PortalVue from 'portal-vue'


import App from './App.vue'

import router from './router'
import messages from './locales'

import store from './store/index'
import { initClarity } from './utils/clarity'
import i18nDebug, { translationMap } from './plugins/i18nDebug'

import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

import * as Sentry from "@sentry/vue"
import { version } from '../package.json'

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable)



import GoogleAuth from 'vue-google-oauth2'
import { startUpdateWatcher } from './utils/appVersion'
const gauthOption = {
  clientId: '449216615581-rbtg6qp7g5ctaj1nbotj04ch677ab6kc.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/business.manage',
  access_type: 'offline',
  prompt: 'consent'
}
Vue.use(GoogleAuth, gauthOption)

// prod : redirect to saas.mashup-web.com
if (process.env.NODE_ENV == 'production' && window.location.href.includes('beta.saas'))
  window.location.href = window.location.href.replace('beta.saas', 'saas')

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#2f1937',
      success: '#b44884',
      danger: 'rgb(242, 19, 93)',
      warning: '#2f1937',
      dark: '#2f1937'
    }
  }
})

Vue.use(VueAnalytics, {
  //id: 'UA-88262954-6',
  id: 'UA-111283719-1',
  autoTracking: {
    pageviewOnLoad: true
  }
})

Vue.use(VueGtag, {
  config: { id: 'G-GVGE5F773F' }
}, router)

Vue.use(VueI18n)
Vue.use(VueResource)


import TokenPlugin from './plugins/conciergerieTokenPlugin'
Vue.use(TokenPlugin, { store })

import SessionRevokedPlugin from './plugins/sessionRevokedPlugin'
Vue.use(SessionRevokedPlugin)

Vue.use(VeeValidate, {
  dictionary: {
    en: VeeValidate_messages_en,
    fr: VeeValidate_messages_fr
  }
})

Vue.use(PortalVue)
Vue.use(i18nDebug)

//use EN messages if locale is empty
Object.keys(messages).forEach(l => {
  Object.keys(messages[l]).forEach(k => {
    if (messages[l][k] == '')
      messages[l][k] = messages['en'][k]
  })
})

const i18n = new VueI18n({
  locale: localStorage.getItem('language')
    || navigator.languages.find((l) => l.length == 2)
    || navigator.language.split('-')[0]
    || 'fr',
  messages,
  postTranslation: localStorage.getItem('adminTraduction') === 'true'
    ? (str, key) => { const t = str?.toString?.()?.trim(); if (t) translationMap.set(t, key); return str }
    : undefined
})

Object.defineProperty(Vue.prototype, '$globals', {
  value: {},
  writable: false
})

Sentry.init({
  Vue,
  dsn: "https://d711cbebd05f1b971ff720d701dfbd24@o149635.ingest.us.sentry.io/4511694160199680",
  environment: process.env.NODE_ENV,
  release: `dashboard@${version}`,
  ignoreErrors: [
    // <video>/<audio> play()/load()/pause() races are expected browser behavior (documented at
    // https://goo.gl/LdLk22), not app bugs - they fire whenever playback is interrupted by a new
    // source or pause() while switching preview media (FRONT-SAAS-N, P, Q).
    /The play\(\) request was interrupted/,
    /Failed to load because no supported source was found/,
    /The element has no supported sources/,

    // Fetch cancelled by browser navigation/unmount, not an app bug (FRONT-SAAS-2B).
    /The operation was aborted/,

    // emoji-mart-vue-fast internal IntersectionObserver race: RecycleScroller calls
    // observer.observe() on a node that got unmounted first - third-party code, no
    // first-party hook to guard it from our side (FRONT-SAAS-G). Two phrasings seen
    // across browsers for the same underlying null-observer race.
    /Cannot read propert(y|ies) of null \(reading 'observe'\)/,
    /observer is null/,

    // Generic network-level failure (wifi drop, VPN, ad-blocker) surfaced by axios,
    // not an app bug - nothing to catch/guard on our side (FRONT-SAAS-1Q).
    /^Network Error$/,

    // vuesax internal ref race on popup close ($refs.btnclose not ready) - third-party
    // code, no first-party hook to guard it from our side (FRONT-SAAS-3M).
    /Cannot read propert(y|ies) of undefined \(reading '\$el'\)/,
  ],
  beforeSend(event) {
    // Third-party cookie-consent (CMP) script, not our code - its own fetch() to its
    // profile endpoint fails independently of our app (FRONT-SAAS-DK, EC, EB, DM).
    if (event.culprit && event.culprit.includes('pa/21964')) {
      return null
    }
    event.exception?.values?.forEach(exception => {
      if (exception.value) {
        exception.value = `[${event.environment}] ${exception.value}`
      }
    })
    return event
  },
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  }
});

// Loaded as a plain <script> from public/index.html (see public/vendor/datadog/datadog-rum.js).
// The npm package's ESM/CJS re-export graph isn't resolvable by this project's webpack 4 setup,
// so we use Datadog's self-contained browser bundle and its window.DD_RUM global instead.
window.DD_RUM?.init({
  applicationId: process.env.VUE_APP_DATADOG_APPLICATION_ID,
  clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.eu',
  service: 'dashboard',
  env: process.env.NODE_ENV,
  version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

initClarity()

// The PWA service worker was removed; drop any registration left in browsers not yet reached by the kill switch
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {})
}
startUpdateWatcher()

// @datadog/browser-rum-vue's error/router integrations require Vue 3 + vue-router v4,
// incompatible with this Vue 2 app. Chain into Sentry's errorHandler instead so both
// tools keep receiving Vue errors.
const sentryErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = (err, vm, info) => {
  window.DD_RUM?.addError(err, { vue: { componentName: vm?.$options?.name, info } })
  sentryErrorHandler?.(err, vm, info)
}

new Vue({
  i18n,
  router,
  render: h => h(App),
  store,
}).$mount('#app')
